import styled from '@emotion/styled';
import { Sidebar } from 'components/sidebar/Sidebar';
import { Topbar } from 'components/topbar/Topbar';

export const Layout = ({
  children,
  hideTopbar = false,
  topbarInviteActions,
  canShareInviteCode,
}: {
  children: React.ReactNode;
  hideTopbar?: boolean;
  topbarInviteActions?: React.ReactNode;
  canShareInviteCode?: boolean;
}) => {
  return (
    <LayoutWrapper hideTopbar={hideTopbar}>
      <Sidebar>
        {!hideTopbar ? (
          <Topbar inviteActions={topbarInviteActions} canShareInviteCode={canShareInviteCode} />
        ) : null}
        <main>{children}</main>
      </Sidebar>
    </LayoutWrapper>
  );
};

const LayoutWrapper = styled.div<{ hideTopbar?: boolean }>`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  overflow: hidden;

  main {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    background-color: ${p => p?.theme.palette.bg.secondary};
    padding: 24px;
    height: ${p => (p?.hideTopbar ? '100vh' : 'calc(100vh - 96px)')};
    overflow-x: hidden;
    overflow-y: hidden;
  }
`;
